import { InjectionToken } from '@angular/core';

export const API_V0_URL = new InjectionToken<string>('Url to API v0 root');
export const API_V2_URL = new InjectionToken<string>('Url to API v2 root');
export const API_V3_URL = new InjectionToken<string>('Url to API v3 root');
